// extracted by mini-css-extract-plugin
export default {"main":"App_main__dhRVK","app":"App_app__JAwbS"};